import React, { useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { FormattedMessage, useIntl } from 'react-intl';
import { yesNoOptions, formatIdFromName } from 'lib/utility';
import { getProfileElementLocale } from 'lib/i18n';
import ProfileElementField from 'lib/components/ProfileElementField';
import ValidationStore, { addValidation } from 'lib/stores/validationStore';
import FormStore, { handleChange } from 'lib/stores/formStore';
import useFormField from 'lib/hooks/useFormField';

import FormRadio from './FormRadio';

const FormRadioUploader = ({ profileElement, name, label, attachmentName, page }) => {
  const intl = useIntl();
  const [value] = useFormField(name);
  const yesLabel = getProfileElementLocale('host', page, `yes_${label}`);
  const noLabel = getProfileElementLocale('host', page, `no_${label}`);
  const attachmentExisting = typeof (FormStore.currentState.attachments[attachmentName].existing) === 'string';
  const attachedFile = FormStore.currentState.attachments[attachmentName].file;

  useEffect(() => {
    if (attachmentExisting) return;

    if (value !== 'true') {
      ValidationStore.update(s => addValidation(s, `profile_elements.dhn.${attachmentName}`, true));
      handleChange(null, `attachments.${attachmentName}.file`);

      return;
    }

    ValidationStore.update(s => addValidation(s, `profile_elements.dhn.${attachmentName}`, !!attachedFile));
  }, [value, attachedFile]);

  return (
    <>
      <ProfileElementField element={profileElement}>
        <FormRadio
          name={name}
          label={getProfileElementLocale('host', page, label)}
          options={yesNoOptions}
          disabled={attachmentExisting}
        />
      </ProfileElementField>
      {value === 'true' && (
        <>
          <div className="mb-3">
            {yesLabel && (
              <p className="fw-bold">
                {'* '}
                <FormattedMessage {...yesLabel} />
              </p>
            )}
            <input
              type="file"
              aria-label={`${attachmentName} file upload`}
              className="form-control"
              name={`attachments.${attachmentName}.file`}
              data-testid={`${formatIdFromName(attachmentName)}File`}
              onChange={e => handleChange(e.target.files[0], e.target.name)}
            />
          </div>
          {attachmentExisting && (
            <div className="alert alert-warning" role="alert">
              {FormStore.currentState.attachments[attachmentName].existing}
              {' '}
              has already been uploaded
            </div>
          )}
        </>
      )}
      {noLabel.defaultMessage && value === 'false' && (
        <p className="me-2 mb-3 fw-bold">
          {ReactHtmlParser(intl.formatMessage(noLabel))}
        </p>
      )}
    </>
  );
};

export default FormRadioUploader;
